import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter, BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CustomThemeProvider from "./providers/CustomThemeProvider";
import { FirebaseAuthProvider } from "./providers/FirebaseAuthProvider";

const store = configureStore({ reducer: rootReducer, devTools: true });

const root = ReactDOM.createRoot(document.getElementById("root"));

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY);
root.render(
  <Provider store={store}>

    <React.Fragment>
      <Elements stripe={stripePromise}>
        <BrowserRouter

        >
          <FirebaseAuthProvider>
            <CustomThemeProvider>
              <App />
            </CustomThemeProvider>
          </FirebaseAuthProvider>
        </BrowserRouter>
      </Elements>
    </React.Fragment>


  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
